import React, { useState } from 'react';
import Dialog from 'epn-ui/umd/dist/components/Dialog';
import Button from 'epn-ui/umd/dist/components/Button';
import Select from 'epn-ui/umd/dist/components/Select';
import useI18n from '@i18n';
import BaseEmpty from '@base/BaseEmpty';
import apiHooks, { ICreateUseRequestInfiniteResponse } from '@apiHooks/index';
import { IGetPlacementsDataFormatted } from '@api/types';
import { ICouponProps } from '../interfaces';

const { usePlacements } = apiHooks;

interface IModalSelectPlacementProps {
    onLink: (
        offerId: number,
        couponLink: string,
        promocode: string,
        placementId: number,
        material?: string,
    ) => void;
    onClose: () => void;
    coupon: ICouponProps;
}

const ModalSelectPlacement: React.FC<IModalSelectPlacementProps> = ({
    coupon,
    onClose,
    onLink,
}) => {
    const { t } = useI18n('Coupons');
    const { t: tCommon } = useI18n('Common');
    const [loading, setLoading] = useState(false);
    const [currentPlacement, setCurrentPlacement] = useState<number>(null);

    const { data: placements = [], isLoading: placementsIsLoading } = usePlacements({
        params: {
            offerIds: coupon.offerId,
            fields: 'id,offer_id,url',
            statuses: 'allow',
            limit: 10,
            offset: 0,
        },
        dependencies: [coupon.offerId],
    }) as ICreateUseRequestInfiniteResponse<IGetPlacementsDataFormatted[]>;

    const onGetLink = async () => {
        setLoading(true);

        await onLink(coupon.offerId, coupon.url, coupon.promocode, currentPlacement, 'wm-coupon');

        setLoading(false);
    };

    return (
        <Dialog onCancel={onClose} open size="sm" loading={placementsIsLoading}>
            <div className="p-2 xs:p-4">
                <p className="font-bold xs:text-center text-blueGray-800 text-[18px] leading-[27px] xs:text-[24px] xs:leading-[35px]">
                    {t('Select placement')}
                </p>
                <p className="mt-2 xs:text-center text-blueGray-600 text-[14px] leading-[21px]">
                    {t('Only permitted placements are displayed in the list')}
                </p>
                <Select
                    className="w-full mt-6"
                    value={currentPlacement}
                    onChange={value => setCurrentPlacement(value)}
                    options={placements}
                    placeholder={t('Select placement')}
                    notFoundContent={<BaseEmpty />}
                    fieldNames={{
                        label: 'url',
                        value: 'id',
                    }}
                />
                <div className="w-full mt-6">
                    <Button
                        type="primary"
                        disabled={currentPlacement === null}
                        className="w-full"
                        loading={loading}
                        onClick={onGetLink}
                    >
                        {tCommon('Get link')}
                    </Button>
                </div>
            </div>
        </Dialog>
    );
};

export default ModalSelectPlacement;
